import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from '../../utils/experience/main.tsx';
import type { JPDExperience } from '../../utils/experience/types.tsx';

export const openDialog: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.view-permissions.open-dialog', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	}),
);

export const loadViewAccess = createJpdExperience(
	new UFOExperience('jpd.view-permissions.load-view-access', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const updateViewAccess = createJpdExperience(
	new UFOExperience('jpd.view-permissions.update-view-access', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const updatePrincipals = createJpdExperience(
	new UFOExperience('jpd.view-permissions.update-principals', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadCurrentUserViewPermissions = createJpdExperience(
	new UFOExperience('jpd.view-permissions.load-current-user-view-permissions', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);
